import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Message, MenuItem} from 'primeng/primeng';
// import { LoginService } from '../../service/login/login.service';
import { TranslateService } from '@ngx-translate/core';
// import { LoginCandidateService } from '../../service/login-candidate/login-candidate.service';
// import { AccountService } from '../../service/account/account.service';
import { LoginCandidateService } from '../../../employee/service/login-candidate/login-candidate.service';
import { AccountService } from '../../../employee/service/account/account.service';


@Component({
  selector: 'app-login-candidate',
  templateUrl: './login-candidate.component.html',
  styleUrls: ['./login-candidate.component.scss']
})
export class LoginCandidateComponent implements OnInit {

  public form: FormGroup;
  public email: AbstractControl;
  public password: AbstractControl;
  public submitted = false;
  public msgs: Message[] = [];
  public langs: Object;
  public openLang = false;
  public welcomeMsg: string;
  public loading: boolean = false;
  fieldTextType: boolean = false;

  constructor(
    fb: FormBuilder,
    private loginCandidateService: LoginCandidateService,
    private router: Router,
    public translate: TranslateService,
    private accountService: AccountService,
  )
  {
    if(this.loginCandidateService.loggedIn()){
      if(this.loginCandidateService.isCandidateUser()) //isCandidateUser
        this.router.navigate(['/candidate/curriculum']);
      else
        this.router.navigate(['/login']);

    }
    this.translate.use('es');

    this.translate.get('welcome').subscribe((res: string) => {
        this.welcomeMsg = res;
    });

    this.form = fb.group({
      'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
      'password': ['', Validators.compose([ Validators.required, Validators.minLength(4) ])]
    });

    this.email = this.form.controls['email'];
    this.password = this.form.controls['password'];

  }

  public onSubmit(values: Object): void {
    this.submitted = true;

    if (this.form.valid) {
      this.loading = true;
      this.loginCandidateService.login(values).toPromise().then(
        response => {
          localStorage.setItem('token', response.json().token);
          this.loginCandidateService.refreshToken();
          this.getAccount();
          // this.loading = true;
        },
        error => {
          this.loading = false;
          let errorMsg = '';
          if ( error.status === 401 ) {
            this.translate.get('Unauthorized').subscribe((res: string) => {
              errorMsg = res;
            });
          }
          if ( error.status === 422 ) {
            errorMsg = 'Error';
          }
          if ( error.status === 500 ) {
            errorMsg = 'Error';
          }
          this.msgs = [];
          this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
        }
      );
    }
  }

  public getAccount() {
    if ( this.loginCandidateService.loggedIn() ) {
      this.accountService.getAccountCandidate().toPromise().then(
        response => {
          localStorage.setItem('profile', JSON.stringify(response.json()));
          if(this.loginCandidateService.isCandidateUser()){
            this.getAccountPermissions();
          }
          else{
            alert("No tiene usuario registrado");
            this.loginCandidateService.logout();
          }
        },
        error => {
          let errorMsg = '';
          if ( error.status === 401 ) {
            this.translate.get('Unauthorized').subscribe((res: string) => {
              errorMsg = res;
            });
          }
          if ( error.status === 422 ) {
            errorMsg = 'Error';
          }
          if ( error.status === 500 ) {
            errorMsg = 'Error';
          }
          this.msgs = [];
          this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
        }
      );
    }
  }

  public getAccountPermissions() {
    if ( this.loginCandidateService.loggedIn() ) {
      this.accountService.getAccountPermissions().toPromise().then(
        response => {
          localStorage.setItem('permissions', JSON.stringify(response.json()));
          this.router.navigateByUrl('candidate/curriculum');
        },
        error => {
          let errorMsg = '';
          if ( error.status === 401 ) {
            this.translate.get('Unauthorized').subscribe((res: string) => {
              errorMsg = res;
            });
          }
          if ( error.status === 422 ) {
            errorMsg = 'Error';
          }
          if ( error.status === 500 ) {
            errorMsg = 'Error';
          }
          this.msgs = [];
          this.msgs.push( { severity: 'error', summary: 'Error', detail: errorMsg } );
        }
      );
    }
  }

  public openSelectLang() {
    event.preventDefault();
    this.openLang = !this.openLang;
  }

  public changeLang(lang) {
    event.preventDefault();
    this.translate.use(lang);
    this.openLang = false;
  }

  ngOnInit() {
    this.langs = [
      {
        label: 'Español', abr: 'es',
      },
      {
        label: 'English', abr: 'en',
      }
    ];
  }

  public gotoNewUser() {
    this.router.navigate(['register']);
  }

  toggleFieldTextType(field_password: number) {
    if(field_password == 1)
      this.fieldTextType = !this.fieldTextType;
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/components/login-candidate/login-candidate.component.ts